/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import ViewerControllerIframe from '../viewer/controller/viewer-controller-iframe';

/**
 * @implements {ViewerType}
 */
class KioskViewerType {
  /**
   * Vytvoří instanci.
   * @param {number} loadDelay
   * @param {HtmlIframePreflighter} preflighter
   * @param {ViewerSourceCreator} sourceCreator
   */
  constructor(loadDelay, preflighter, sourceCreator) {
    this.loadDelay = loadDelay;
    this.preflighter = preflighter;
    this.sourceCreator = sourceCreator;
  }

  /** @inheritdoc */
  createController() {
    return new ViewerControllerIframe(this.loadDelay, this.preflighter, {
      scroll: true
    });
  }

  /** @inheritdoc */
  getCheckFile(medium) {
    // Kiosky nemají v detailu média nastavení "Kontrolovat aktuální verzi".
    return false;
  }

  /** @inheritdoc */
  getSourceCreator() {
    return this.sourceCreator;
  }

  /** @inheritdoc */
  getUrl(medium) {
    return new Promise((resolve) => resolve(medium.url ?? undefined));
  }

  /** @inheritdoc */
  isExtractable() {
    return false;
  }

  /** @inheritdoc */
  isOfflineable() {
    return false;
  }

  /** @inheritdoc */
  isPreloadable(medium) {
    // U kiosků se moc nepočítá s tím, že by byly spuštěné někde na pozadí.
    // Dělá to problémy při naslouchání na události, např. události ovládání.
    // Byl řešen problém s autofocus, který se nechoval při preloadu správně.
    // Také nelze jednoduše vypnout zvuky, které mohou vznikat.
    // Proto je preload zakázaný.
    return false;
  }

  /** @inheritdoc */
  isSeekable(medium) {
    return false;
  }

  /** @inheritdoc */
  isStatic(medium) {
    return true;
  }
}

export default KioskViewerType;
